import React, { useRef, useState } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';

const App: React.FC = () => {
  const [image, setImage] = useState<string | ArrayBuffer | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const cropperRef = useRef<HTMLImageElement>(null);

  const onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      console.log("image file selected", event.target.files[0])
      const reader = new FileReader();
      reader.onload = () => setImage(reader.result);
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const onCrop = () => {
    if (cropperRef.current) {
      const cropper = (cropperRef.current as any).cropper;
      setCroppedImage(cropper.getCroppedCanvas().toDataURL());
    }
  };

  const onUpload = async () => {
    if (croppedImage) {
      const blob = await fetch(croppedImage).then(res => res.blob());
      const formData = new FormData();
      formData.append('file', blob, 'croppedImage.png');

      try {
        const response = await axios.post('http://localhost:3021/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log('Upload successful:', response.data);
      } catch (error) {
        console.error('Upload error:', error);
      }
    }
  };

  return (
    <div>
      <input type="file" accept="image/*" onChange={onSelectFile} />
      {image && (
        <Cropper
          src={image as string}
          style={{ height: 400, width: '100%' }}
          aspectRatio={1}
          viewMode={1}
          guides={false}
          ref={cropperRef}
          crop={onCrop}
        />
      )}
      {croppedImage && (
        <div>
          <h2>Cropped Image</h2>
          <img src={croppedImage} alt="Cropped" style={{ borderRadius: '50%' }} />
        </div>
      )}
      <button onClick={onUpload}>Upload</button>
    </div>
  );
};

export default App;
